import Vue from 'vue';
import { Component , Prop , PropSync, Watch} from 'vue-property-decorator';
import { createEventBus, getLangProperty, removeEventBus} from '@appbase/util';
import { openPopup } from '@/modules/@appbase/util';
import GridView from '@appbase/components/GridView/GridView.vue'

export interface TWishContainerOptionItem {
    id: number
    name: string
    height: string
    items? : orgmap.TWishContainerItem[]
}

export interface TWishContainerOptions {
    addableDept: boolean,
    single: boolean,
    personal: boolean,
    public: boolean,
    containers: TWishContainerOptionItem[]
}

export interface TWishItemPropsOptions {
    props: string[]
}

export interface receiver {
    userName: string,
    userCode: string,
    deptCode: string,
    deptName: string,
    userEmail: string
}

const EVENT_ORG_POPUP = '$board/write/org/popup'

@Component({
    components: { GridView }
})

export default class MailSendField extends Vue {
    @Prop ({ type: Object }) context!: board.ContentField;
    @PropSync('returnValue', { type: String }) fieldValue!: string;

    receiversModel: gridView.ModelItem<any>[] = [];
    receiversHeaders: gridView.Header[] = [];

    receivers: receiver[] = [];
    selected: any[] = [];

    created() {
        createEventBus(window, EVENT_ORG_POPUP, this.handlePopupResult);
        this.receivers = JSON.parse(this.context.fieldPreset) || [];

        if (this.fieldValue) {
            var receiverArr =  JSON.parse(this.fieldValue);
            receiverArr.forEach((receiver: receiver) => {
                if(!(this.receivers.findIndex(r => receiver.userEmail === r.userEmail) >= 0)) {
                    this.receivers.push(receiver)
                }
            })
        }

        this.receiversHeaders = [
            { displayName: this.$t('이름').toString(), rowKey: 'userName', align: 'left', slotName: 'userName', width: '30%' },
            { displayName: this.$t('이메일').toString(), rowKey: 'userEmail', align: 'left', slotName: 'userEmail', width: '*' },
        ]      
    }

    beforeDestroy() {
        removeEventBus(window, EVENT_ORG_POPUP, this.handlePopupResult);
    }

    get displayName() {
        return getLangProperty(this.context, 'displayName');
    }

    @Watch('receivers')
    onReceiversChanged(newVal: any[]) {
        this.receiversModel = newVal;
        this.fieldValue = JSON.stringify(newVal);
    }

    onOrgmapPopup() {
        const orgmapOption: TWishContainerOptions = {
            addableDept: true,
            single: false,
            personal: false,
            public: false,
            containers: [
               { id: 0, name: '받는사람', height: '1' }               
            ] 
        }

        const props: TWishItemPropsOptions = {
            props: ['name', 'personCode', 'deptCode', 'deptName', 'email'],
        }

        openPopup('mailSend', '/orgmap', 
            { event: EVENT_ORG_POPUP, option: orgmapOption, props }, 
            { width: 1024, height: 768 });
    }

    handlePopupResult(data: any) {          
        if(data && data.length > 0) {
            var popupResult: any[] = data[0].items;
            popupResult.forEach(p => {
                if(!(this.receivers.findIndex(r => p.email === r.userEmail) >= 0)) {
                    this.receivers.push({
                        userName: p.name,
                        userCode: p.personCode,
                        deptCode: p.deptCode,
                        deptName: p.deptName,
                        userEmail: p.email,
                    })
                }
            })
        }
    }

    onDeleteItem() {
        this.selected.forEach(item => {
            var index = this.receivers.findIndex(r => r.userCode === item.userCode)
            this.receivers.splice(index, 1)
        })
    }

    onSelected(items: any[]) {
        this.selected = items;
    }
}